import React, { useContext } from "react";
import { Grid } from "react-feather";
import { Link } from "react-router-dom";
import CustomizerContext from "../../Helper/Customizer";
import cubaimg from "../../assets/images/logo/parikrama-logo.png";
import { Image } from "../../AbstractElements";
import logoPath from "../../assets/images/logo/Gradient.svg";
const SidebarLogo = () => {
  const { togglSidebar, setTogglSidebar } = useContext(CustomizerContext)

  return (
    <>
      <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
        {/* <Image attrImage={{
          className: "img-fluid for-light",
          src: cubaimg,
          alt: "",
          style: { height: "75px" } // Set your desired height
        }} /> */}
        <img 
          src={logoPath} 
          alt="Test Logo Img" 
          style={{ height: "70px" }} 
        />
      </Link>
      <div className="back-btn" onClick={() => setTogglSidebar(!togglSidebar)}>
        <Grid />
      </div>
      <div className="toggle-sidebar" onClick={() => setTogglSidebar(!togglSidebar)}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </>
  );
};

export default SidebarLogo;
